module.exports = __webpack_public_path__ + "assets/images/home/medal@2x.png";